module.exports = __webpack_public_path__ + "images/fa-thank-you-bg.jpg";